export const getUser = (state) => state.auth.user;
export const getErrors = (state) => state.auth.errors;
export const hasError = (state) => state.auth.isError;
export const getLoading = (state) => state.auth.isLoading;